<template>
<div>
<pop-up-layout 
  :title="$t('reservas.listas.sincronizar')"
  :aceptar="$t('reservas.listas.aceptar')"
  :saving="waitingForLoad"
  @volver="$parent.hide()"
  @aceptar="sincronizar()"
>
  <v-layout column justify-center align-center>
    <o-description-title class="text-xs-center" style="margin-top: 10px">
      {{$t('reservas.listas.sincronizarReserva', {reserva: reservaSeleccionada.inmueble_descripcionLarga})}}
    </o-description-title>
  </v-layout>
</pop-up-layout>
<v-fade-transition>
  <custom-dialog v-if="mostrarErrorSincronizacion" v-model="mostrarErrorSincronizacion" :noCerrar="true">
    <PopUpSincronizacion
      @hide="mostrarErrorSincronizacion = false"
      :error="errorSincronizacion"
      :textoBoton="$t('reservas.listas.aceptar')"
    />
  </custom-dialog>
</v-fade-transition>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import modulos from '@/mixins/modulos'
import PopUpSincronizacion from '@/components/generic/PopUpSincronizacion'

export default {
  mixins: [
    modulos
  ],
  props: ['reservaSeleccionada'],
  components: {
    PopUpSincronizacion
  },
  data () {
    return {
      waitingForLoad: false,
      mostrarErrorSincronizacion: false,
      errorSincronizacion: ''
    }
  },
  computed: {
    ...mapGetters({
      reserva: 'reservas/_id/getActual'
    })
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      sincronizarReserva: 'reservas/sincronizarReserva'
    }),
    async sincronizar () {
      try {
        this.waitingForLoad = true
        this.$parent.noCerrarInterno = true
        this.errorSincronizacion = ''
        this.mostrarErrorSincronizacion = false
        await this.sincronizarReserva(this.reservaSeleccionada.id)
        if (this.reserva.sincronizada) {
          this.addAlert({texto: this.$t('reservas.listas.sincronizadaExito'), color: 'success'})
          this.$emit('recargar')
        } else {
          this.addAlert({texto: this.$t('reservas.listas.sincronizadaError'), color: 'error'})
        }
        this.$parent.hide()
        this.waitingForLoad = false
        this.$parent.noCerrarInterno = false
      } catch (error) {
        this.waitingForLoad = false
        this.$parent.noCerrarInterno = false
        this.mostrarErrorSincronizacion = true
        if (!error.code || error.code !== 1) {
          this.errorSincronizacion = error.message
          // this.addAlert({texto: error.message, color: 'error'})
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/reservas/listas/PopUpSincronizar.vue